var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtnLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.542,
    height: 36.544,
    viewBox: "0 0 32.542 36.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6085",
    "data-name": "Path 6085",
    d: "M20.889,207.394l2.251-5.7-9.161-3.131Z",
    transform: "translate(-12.027 -170.85)",
    fill: "#36bdba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6086",
    "data-name": "Path 6086",
    d: "M63.485,226.694l15.28-1.237L65.736,221Z",
    transform: "translate(-54.624 -190.149)",
    fill: "#3cc3e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6087",
    "data-name": "Path 6087",
    d: "M22.443,100.567l-8.461,13.679,22.19,7.588Z",
    transform: "translate(-12.03 -86.529)",
    fill: "#1aa3dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6088",
    "data-name": "Path 6088",
    d: "M.271,145.571l1.914,6.337,4.682-7.569Z",
    transform: "translate(-0.233 -124.192)",
    fill: "#efb121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6089",
    "data-name": "Path 6089",
    d: "M74.6,15.74,83.185,1.979l-.9,25.675Z",
    transform: "translate(-64.186 -1.703)",
    fill: "#383f93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6090",
    "data-name": "Path 6090",
    d: "M.06,96.788l3.87-.724L.025,87.64Z",
    transform: "translate(-0.021 -75.407)",
    fill: "#ee7b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6091",
    "data-name": "Path 6091",
    d: "M.016,62.4l6.631,7.914L14.109,58.3Z",
    transform: "translate(-0.014 -50.163)",
    fill: "#e52743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6092",
    "data-name": "Path 6092",
    d: "M2.657,96.287l3.99-.732L.016,87.64Z",
    transform: "translate(-0.014 -75.407)",
    fill: "#e0272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6093",
    "data-name": "Path 6093",
    d: "M0,36.166l8.862-2.575L5.13,27.815Z",
    transform: "translate(0 -23.933)",
    fill: "#b02a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6094",
    "data-name": "Path 6094",
    d: "M44.669,0,36.753,3.882l3.731,5.776Z",
    transform: "translate(-31.623)",
    fill: "#d6197f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6095",
    "data-name": "Path 6095",
    d: "M63.481,9.666l5.234-1.521L67.667.009Z",
    transform: "translate(-54.62 -0.008)",
    fill: "#6e3891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6096",
    "data-name": "Path 6096",
    d: "M94.523,8.144l4.9-7.86L93.476.009Z",
    transform: "translate(-80.428 -0.008)",
    fill: "#b02a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6097",
    "data-name": "Path 6097",
    d: "M132.559,16.167l.5-14.178,3.391,11.046Z",
    transform: "translate(-114.056 -1.711)",
    fill: "#d6197f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6098",
    "data-name": "Path 6098",
    d: "M143.07,10.134l-6.956-8.164,3.39,11.05Z",
    transform: "translate(-117.114 -1.696)",
    fill: "#b02a89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6099",
    "data-name": "Path 6099",
    d: "M137.123,109l-7.027-5.436-.4,11.5Z",
    transform: "translate(-111.591 -89.107)",
    fill: "#b02a89",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6100",
    "data-name": "Path 6100",
    d: "M143.171,74.672l-10.612-8.206,7.452-6.018Z",
    transform: "translate(-114.055 -52.01)",
    fill: "#383f93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6101",
    "data-name": "Path 6101",
    d: "M187.716,68.42l4.814-2.4-6.584-5.562Z",
    transform: "translate(-159.991 -52.017)",
    fill: "#6e3891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6102",
    "data-name": "Path 6102",
    d: "M198.627,102.706l1.389,6.259,3.425-8.661Z",
    transform: "translate(-170.902 -86.303)",
    fill: "#2d4091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6103",
    "data-name": "Path 6103",
    d: "M219.147,105.235l1.93,6.365.022-11.3Z",
    transform: "translate(-188.558 -86.304)",
    fill: "#14509b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6104",
    "data-name": "Path 6104",
    d: "M142.173,135.581l-1.474,3.737-3.586-2.771-7.428,6.061,14.418-.656Z",
    transform: "translate(-111.584 -116.656)",
    fill: "#5b3991",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6105",
    "data-name": "Path 6105",
    d: "M143.116,185.179l1-3.961-14.417.656Z",
    transform: "translate(-111.591 -155.923)",
    fill: "#14509b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    d: "M143.116,189.225l-7.384,6.049-6.038-9.353Z",
    transform: "translate(-111.591 -159.969)",
    fill: "#2d3b87",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtnLogo);
export default __webpack_public_path__ + "static/media/ttn-logo.722f9a81f2f3e41e8c99a701494d910e.svg";
export { ForwardRef as ReactComponent };